jQuery(document).ready(function ($) {
  if (typeof ScrollMagic === "function") {
    var controller = new ScrollMagic.Controller(); // build scenes

    if ($('.m-home-hero__wrapper')) {
      var revealElements = document.getElementsByClassName("m-home-hero__wrapper");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    } // build scenes

    if ($('.m-columns__wrap')) {
      var revealElements = document.getElementsByClassName("m-columns__wrap");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.m-animated-image')) {
      var revealElements = document.getElementsByClassName("m-animated-image");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.m-cards')) {
      var revealElements = document.getElementsByClassName("m-cards");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.m-image-quote')) {
      var revealElements = document.getElementsByClassName("m-image-quote");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.m-resources__wrap')) {
      var revealElements = document.getElementsByClassName("m-resources__wrap");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.m-animated-title')) {
      var revealElements = document.getElementsByClassName("m-animated-title");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.m-animated-paragraph')) {
      var revealElements = document.getElementsByClassName("m-animated-paragraph");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.m-solutions__item')) {
      var revealElements = document.getElementsByClassName("m-solutions__item");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          reverse:false,
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.m-text-image-block')) {
      var revealElements = document.getElementsByClassName("m-text-image-block");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }
    if ($('.m-page-body__featured-image')) {
      var revealElements = document.getElementsByClassName("m-page-body__featured-image");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.wp-block-image')) {
      var revealElements = document.getElementsByClassName("wp-block-image");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

    if ($('.wp-block-image')) {
      var revealElements = document.getElementsByClassName("wp-block-image");

      for (var i = 0; i < revealElements.length; i++) {
        // create a scene for each element
        new ScrollMagic.Scene({
          triggerElement: revealElements[i],
          // y value not modified, so we can use element as trigger as well
          // offset: 50,												 // start a little later
          triggerHook: 0.7
        }).setClassToggle(revealElements[i], "is-visible") // add class toggle
          // .addIndicators({name: "m-slider " + (i+1) }) // add indicators (requires plugin)
          .addTo(controller);
      }
    }

  }

  document.addEventListener( 'wpcf7mailsent', function( event ) {

    if ( '133' == event.detail.contactFormId ) {
      document.querySelector(".m-contact-form").classList.add("hidden");
      document.querySelector(".m-contact-form__text").classList.add("hidden");
      setTimeout( function() {
            
            document.querySelector(".m-contact-form__success").classList.remove("hidden");
        }, 200);
    }

  }, false );

}) // End jQuery